import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { initGA, logPageView } from "./utils/analytics";
import CustomNavbar from "./components/Navbar/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import SellNumbers from "./pages/SellNumbers";
import "./App.css";
// import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// const AnalyticsTracker = () => {
//   const location = useLocation();

//   useEffect(() => {
//     logPageView(location.pathname + location.search);
//   }, [location]);

//   return null;
// };

function App() {

  // useEffect(() => {
  //   initGA();
  // }, []);

  return (
    <Router>
      {/* <AnalyticsTracker /> */}
      <CustomNavbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="" element={<About />} />
        <Route path="/numbers" element={<SellNumbers />} />
      </Routes>
    </Router>
  );
}

export default App;